const steps = [
  { num: '1', title: 'Диагностика', desc: 'Изучаем реальные задачи руководителей и компании: какие ситуации вызывают трудности, какие цели стоят перед управленческой командой.' },
  { num: '2', title: 'Настройка программы', desc: 'Адаптируем содержание под уровень участников, бизнес-контекст и реальные управленческие ситуации.' },
  { num: '3', title: 'Практическое обучение', desc: 'Разбираем инструменты лидерства и управленческого влияния. Работаем с реальными кейсами, а не абстрактными примерами.' },
  { num: '4', title: 'Отработка', desc: 'Участники тренируются на ситуациях, максимально близких к реальной работе: ролевые ситуации, разбор кейсов, практические упражнения.' },
  { num: '5', title: 'Внедрение', desc: 'Инструменты переносятся в ежедневную управленческую практику. Каждый участник определяет, что начнёт применять с завтрашнего дня.' },
  { num: '6', title: 'Сопровождение', desc: 'При необходимости разбираем ситуации, которые возникают после обучения, помогаем закрепить новые модели поведения.' },
  { num: '7', title: 'Оценка изменений', desc: 'Через 1–3 месяца определяем, какие изменения произошли в управленческом поведении руководителей.' },
];

export default function ProcessSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Как строится программа
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          От обучения к реальному изменению управленческого поведения
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {steps.slice(0, 4).map((step) => (
            <div key={step.num} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 relative">
              <div className="w-10 h-10 rounded-full bg-teal-600 text-white flex items-center justify-center font-bold text-sm mb-4">{step.num}</div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{step.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
        <div className="grid sm:grid-cols-3 gap-5 max-w-3xl mx-auto mt-5">
          {steps.slice(4).map((step) => (
            <div key={step.num} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 relative">
              <div className="w-10 h-10 rounded-full bg-teal-600 text-white flex items-center justify-center font-bold text-sm mb-4">{step.num}</div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{step.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}